import React, { useEffect, useState } from 'react';
import './style.css';
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import { getWatermarkData } from '../../utils/helper';

const WaterMark = () => {
    const [watermarkData, setWatermarkData] = useState(null);
    const { userInfo } = useDocument();

    useEffect(() => {
        let isMounted = true;
        const loadData = async () => {
            const data = await getWatermarkData();
            if (isMounted) setWatermarkData(data);
        };
        loadData();
        return () => { isMounted = false; };
    }, []);


    useEffect(() => {
        if (watermarkData) {
            const sheetContainer = document.getElementsByClassName('x-spreadsheet-sheet')[0];
            const container = document.getElementById("water-mark-container");
            if (sheetContainer && container && !sheetContainer.contains(container)) {
                container.style.display = "block";
                sheetContainer.appendChild(container);
            }
        }
    }, [watermarkData]);
    

    if (!watermarkData) return null;

    const { location, ip, currentDateTime } = watermarkData;

    return (
        <div id="water-mark-container" className="watermark-style">
            <div>User: {userInfo?.name || 'N/A'}</div>
            <div>Location: {location.lat}, {location.lng}</div>
            <div>IP: {ip}</div>
            <div>Time: {currentDateTime}</div>
        </div>
    );
};

export default WaterMark;
